import { defineMessages as e } from "react-intl";
const c = e({
  close: {
    id: "misc-modalClose",
    defaultMessage: "Close"
  }
}), r = e({
  fbWitchCorrect: {
    id: "fbExerciseWitchCorrect",
    defaultMessage: "Correct"
  },
  fbWitchIncorrect: {
    id: "fbExerciseWitchIncorrect",
    defaultMessage: "False"
  },
  fbWitchIncorrectRetry: {
    id: "fbExerciseWitchIncorrectRetry",
    defaultMessage: "False. Try again!"
  }
});
export {
  c as commonMessages,
  r as shellMessages
};
//# sourceMappingURL=messages.js.map
